/** `ez.t.update_created` — *When any update is posted* (recipes 98, 128, 286). */
import { z } from 'zod';
import { defineTrigger } from '../block.js';
export const updateCreatedParams = z.object({});
export const updateCreatedTrigger = defineTrigger({
    id: 'ez.t.update_created',
    kind: 'trigger',
    app: 'monday',
    sentencePartial: 'When any update is posted',
    paramsSchema: updateCreatedParams,
    subscribes: ['update.created'],
    assumed: true,
    references: () => [],
    matches: (event) => event.payload.edited !== true,
    outputs: (event) => ({
        itemId: event.itemId,
        boardId: event.boardId,
        updateId: event.payload.updateId,
        userId: event.payload.createdBy ?? event.actorId,
        /** Recipe 286 offers `{update.preview}` as an extra token (sandbox E14). */
        updatePreview: event.payload.bodyText,
    }),
});
//# sourceMappingURL=ez.t.update-created.js.map